import moment from 'moment';

/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import Localized from '../../../shared/components/Localized';
import { DatePicker } from '../DatePicker/index';
import './Timeline.scss';

export default class TimelineController extends React.Component {
  static propTypes = {
    range: PropTypes.object,
    offset: PropTypes.object,
    zoomIn: PropTypes.func,
    zoomOut: PropTypes.func,
    forward: PropTypes.func,
    back: PropTypes.func,
    now: PropTypes.func,
    selectedDate: PropTypes.object,
    onCalenderChange: PropTypes.func,
    timelineLimit: PropTypes.number
  };

  render() {
    const {
      range,
      offset,
      zoomOut,
      zoomIn,
      now,
      selectedDate,
      onCalenderChange,
      timelineLimit
    } = this.props;
    const currentRange = range.asDays();
    const baseButtonClasses =
      'slds-button slds-button--icon-border timeline-button';
    return (
      <div className="slds-grid slds-nowrap timeline-controller">
        <div className="slds-col slds-size--1-of-2 slds-grid slds-p-left--small slds-p-vertical--small">
          <div className="slds-button-group timeline-controller-buttons">
            <button
              type="button"
              className={
                baseButtonClasses +
                (currentRange === 7 ? ' timeline-button-selected' : '')
              }
              onClick={() => {
                const sevenDayRange = moment.duration(7, 'days');
                zoomOut(sevenDayRange);
              }}
            >
              7{' '}
              <Localized
                modelKey="days"
                modelAttribute="label"
                modelName="timeline"
              />
            </button>
            <button
              type="button"
              className={
                baseButtonClasses +
                (currentRange === 3 ? ' timeline-button-selected' : '')
              }
              onClick={() => {
                const threeDayRange = moment.duration(3, 'days');
                zoomIn(threeDayRange);
              }}
            >
              3{' '}
              <Localized
                modelKey="days"
                modelAttribute="label"
                modelName="timeline"
              />
            </button>
            <button
              type="button"
              className={
                baseButtonClasses +
                (currentRange === 1 ? ' timeline-button-selected' : '')
              }
              onClick={() => {
                const oneDayRange = moment.duration(24, 'hours');
                zoomIn(oneDayRange);
              }}
            >
              24{' '}
              <Localized
                modelKey="hours"
                modelAttribute="label"
                modelName="timeline"
              />
            </button>
          </div>
          <div className="slds-m-right--x-small slds-align--absolute-center timeline-datepicker">
            <DatePicker
              name="timeline-calender"
              placeholder="Select a date"
              value={selectedDate}
              onChange={onCalenderChange}
              readOnly={true}
              dateLimitInDays={timelineLimit}
            />
          </div>
          <button
            id="nowButton"
            className="slds-button slds-button--brand timeline-btn--now"
            onClick={() => {
              now();
            }}
            disabled={offset.asDays() === 0}
          >
            <Localized
              modelKey="now"
              modelAttribute="button"
              modelName="timeline"
            />
          </button>
        </div>
      </div>
    );
  }
}
